/**
 * @generated SignedSource<<ab1806200b39da33c41e837aaec99568>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateMessageDefinitionInput = {
  buttonOpt?: CreateButtonInput | null | undefined;
  clientMutationId?: string | null | undefined;
  internalTitle: string;
  notificationDefinitionOpt?: CreateNotificationDefinition | null | undefined;
  pageImageRef?: string | null | undefined;
  pageInternalTitle: string;
  showUntilOpt?: any | null | undefined;
};
export type CreateButtonInput = {
  buttonType: string;
  link?: string | null | undefined;
  title: string;
};
export type CreateNotificationDefinition = {
  body: string;
  title: string;
};
export type MessageDefinitionOverviewScreen_CreateMessageDefinitionMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateMessageDefinitionInput;
};
export type MessageDefinitionOverviewScreen_CreateMessageDefinitionMutation$data = {
  readonly Admin: {
    readonly Messaging: {
      readonly createMessageDefinition: {
        readonly edge: {
          readonly node: {
            readonly id: string;
            readonly internalTitle: string;
          };
        };
      } | null | undefined;
    };
  };
};
export type MessageDefinitionOverviewScreen_CreateMessageDefinitionMutation = {
  response: MessageDefinitionOverviewScreen_CreateMessageDefinitionMutation$data;
  variables: MessageDefinitionOverviewScreen_CreateMessageDefinitionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "MessageDefinitionsEdge",
  "kind": "LinkedField",
  "name": "edge",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MessageDefinition",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "internalTitle",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MessageDefinitionOverviewScreen_CreateMessageDefinitionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MessagingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Messaging",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "CreateMessageDefinitionPayload",
                "kind": "LinkedField",
                "name": "createMessageDefinition",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MessageDefinitionOverviewScreen_CreateMessageDefinitionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MessagingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Messaging",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "CreateMessageDefinitionPayload",
                "kind": "LinkedField",
                "name": "createMessageDefinition",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "prependEdge",
                    "key": "",
                    "kind": "LinkedHandle",
                    "name": "edge",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5d2b52a51d9fab1f689fc6bb324fc524",
    "id": null,
    "metadata": {},
    "name": "MessageDefinitionOverviewScreen_CreateMessageDefinitionMutation",
    "operationKind": "mutation",
    "text": "mutation MessageDefinitionOverviewScreen_CreateMessageDefinitionMutation(\n  $input: CreateMessageDefinitionInput!\n) {\n  Admin {\n    Messaging {\n      createMessageDefinition(input: $input) {\n        edge {\n          node {\n            id\n            internalTitle\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f77f199ad902705cea1ddfcfb35e611";

export default node;
